import { atom, useAtom } from 'jotai';
import { css } from '@emotion/react';
import { Dialog } from '@mui/material';
import { ViewModel } from '../../../../models/view.model';
import { CHART_COMPONENTS } from '../../../../types';
import { useCurrentViewMetrics } from '../../hooks/useCurrentViewMetrics';
import { GenericFallbacksWrapper } from '../../../../components/Fallback/GenericFallbacksWrapper';
import { getComponentsMap } from './ChartComponent';

export const SelectedChartPfState = atom<CHART_COMPONENTS | null>(null);

const chartContainerCss = css`
  width: 1200px;
  max-width: 95dvw;
  height: 600px;
  max-height: 95dvh;
  display: grid;
  padding: 0;
`;

export function ExpandedChartPf({ view }: { view: ViewModel }) {
  const [selectedChartPf, setSelectedChartPf] = useAtom(SelectedChartPfState);

  return (
    <Dialog open={!!selectedChartPf} onClose={() => setSelectedChartPf(null)} maxWidth='lg' fullWidth>
      {selectedChartPf ? <ExpandedChartPfContent selectedChartPf={selectedChartPf} view={view} /> : null}
    </Dialog>
  );
}

function ExpandedChartPfContent({
  selectedChartPf,
  view,
}: {
  selectedChartPf: CHART_COMPONENTS;
  view: ViewModel;
}) {
  const componentsMap = getComponentsMap();
  const { metrics, filteredMetrics } = useCurrentViewMetrics(view);

  const Component = componentsMap[selectedChartPf];
  if (!Component) {
    return null;
  }

  return (
    <GenericFallbacksWrapper>
      <div css={chartContainerCss}>
        <Component metrics={metrics ?? []} filteredMetrics={filteredMetrics ?? []} view={view} isFullScreen />
      </div>
    </GenericFallbacksWrapper>
  );
}
